import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Selettore fascia oraria (Intera Giornata / Mattina / Pomeriggio) stilizzato a pill.
 * Presentational: il chiamante possiede lo stato e l'handler (come sb-datepicker),
 * tipicamente legato a globalData.fasciaOrariaSelezionata / onFasciaOrariaChange().
 *
 *   <sb-fascia-oraria [(value)]="globalData.fasciaOrariaSelezionata"
 *                     (change)="globalData.onFasciaOrariaChange()"></sb-fascia-oraria>
 */
@Component({
  selector: 'sb-fascia-oraria',
  templateUrl: './sb-fascia-oraria.component.html',
  standalone: false
})
export class SbFasciaOrariaComponent {
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output() change = new EventEmitter<void>();

  onSelectChange(value: any) {
    this.value = value;
    // valueChange PRIMA di change: così il chiamante aggiorna il modello
    // (es. globalData.fasciaOrariaSelezionata) prima che parta onFasciaOrariaChange()
    this.valueChange.emit(value);
    this.change.emit();
  }
}
